module.exports = __webpack_public_path__ + "static/media/active-camera-icon.55b050e4.svg";